import { getFileExtension } from 'helpers/helper_functions';
import { EXTENSION_BASED_MIMETYPES } from 'constants/DocumentDefaults';
export function areSomeFilesEmpty(files) {
    return files.some((file) => !file.size);
}
export function getFilesWithContentType(files) {
    return files.map((file) => {
        var _a;
        if (!((_a = file === null || file === void 0 ? void 0 : file.type) === null || _a === void 0 ? void 0 : _a.length) &&
            (file === null || file === void 0 ? void 0 : file.name) &&
            getFileExtension(file.name) &&
            EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)])
            return new File([file], file.name, {
                type: EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)],
            });
        return file;
    });
}
